<template>
  <el-card shadow="never">
    <template slot="header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: $root.getDashboardPath() }">Dashboard</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'Facility Audit' }">Audit</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'Facility Audit transactions'}">
          {{ $root.getHeader() }} Audit report for Transactions
        </el-breadcrumb-item>
      </el-breadcrumb>
    </template>
    <el-card shadow="never" v-loading="loading">
      <template slot="header">
        <el-date-picker
          v-model="date"
          type="month"
          placeholder="Pick a month"
          @change="getTransactions"
        >
        </el-date-picker>
      </template>
      <el-table :data="transactions" @row-click="routeToCustomer">
        <el-table-column label="Customer" prop="customer.company"></el-table-column>
        <el-table-column label="Type" prop="type"></el-table-column>
        <el-table-column label="Last 4 digits" :width="150">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.source">
            {{  scope.row.source }}</el-tag>
            <div v-else>
              <el-tag
                v-if="scope.row.type === 'ACH' && scope.row.events[1] && scope.row.events[1].details && scope.row.events[1].details.transaction && scope.row.events[1].details.transaction.usBankAccount && scope.row.events[1].details.transaction.usBankAccount.last4">
                {{ scope.row.events[1].details.transaction.usBankAccount.last4 }}
              </el-tag>
              <el-tag
                v-if="scope.row.type === 'ACH' && scope.row.events[1] && scope.row.events[1].details && scope.row.events[1].details.result && scope.row.events[1].details.result.transaction && scope.row.events[1].details.result.transaction.usBankAccount && scope.row.events[1].details.result.transaction.usBankAccount.last4">
                {{ scope.row.events[1].details.result.transaction.usBankAccount.last4 }}
              </el-tag>
              <el-tag
                v-if="scope.row.type === 'ACH' && scope.row.events[1] && scope.row.events[1].details && scope.row.events[1].details.result && scope.row.events[1].details.result.transaction && scope.row.events[1].details.result.transaction.creditCard && scope.row.events[1].details.result.transaction.creditCard.last4">
                {{ scope.row.events[1].details.result.transaction.creditCard.last4 }}
              </el-tag>
              <el-tag v-if="scope.row.type === 'CREDIT_CARD' && scope.row.events[1] && scope.row.events[1].details && scope.row.events[1].details.transaction && scope.row.events[1].details.transaction.creditCard && scope.row.events[1].details.transaction.creditCard.last4">
                <div>{{ scope.row.events[1].details.transaction.creditCard.last4 }}</div>
              </el-tag>
            </div>
            <div v-show="scope.row.type !== 'ACH' && scope.row.type !== 'CREDIT_CARD'">--</div>
          </template>
        </el-table-column>
        <el-table-column label="Status" :width="120">
        <template slot-scope="scope">
          <el-tag v-if="!scope.row.success" :type="scope.row.events[scope.row.events.length - 1].status.toUpperCase() === 'FAILED' ? 'danger' : 'warning' ">
            {{ scope.row.status.toUpperCase() }}
          </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="Updated At" :width="100">
          <template slot-scope="scope">
            {{ new Date(scope.row.updatedAt) | formatDate }}
          </template>
        </el-table-column>
        <el-table-column
          label="Amount" prop="amount"
          :formatter="(row, column, cellValue ) => $options.filters.currencySign(cellValue, this.$root.state.facilityData)"
        ></el-table-column>
        <el-table-column
          label="Return code"
        >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.type === 'ACH' && scope.row.events && scope.row.events[scope.row.events.length - 1] && scope.row.events[scope.row.events.length - 1].details && scope.row.events[scope.row.events.length - 1].details.transaction">
            {{  scope.row.events[scope.row.events.length - 1].details.transaction.achReturnCode || '-' }}
          </el-tag>
        </template>
        </el-table-column>
      </el-table>
    </el-card>
  </el-card>
</template>

<script>
import axios from 'axios';
import { AUDIT_API } from '../env';

export default {
  name: 'AuditTransactions',
  props: {
    facility: { type: String, required: true }
  },
  watch: {
    async facility() {
      await this.getTransactions();
    },
  },
  data() {
    return {
      transactions: [],
      loading: false,
      date: null,
    };
  },
  methods: {
    async getTransactions() {
      this.loading = true;
      const response = await axios.get(`${AUDIT_API}/${this.facility}/transactions`, {
        params: {
          ...(this.date ? {
            month: this.date.getMonth(),
            year: this.date.getFullYear(),
          } : {}),
        },
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });

      this.transactions = response.data.result.transactions;
      this.loading = false;
    },
    routeToCustomer(row) {
      if (this.facility) {
        this.$router.push({ name: 'Facility Customer', params: { id: row.customer._id, facility: this.facility } });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/AuditTransactions.vue